module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAdgAAAHYBTnsmCAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAACtSURBVDiNrdGtioJBGMXxnxh8RfASRO2iQRDZ5tVs326wiIh3Y/ILTHbvwGXbCtvcqMF5xaI4gwcmzMf5H848vFllTNFINS9wRDPWXMIcf+impI9xjlxDKARAC5uw/8LphdAdfu4P2vjFGllKjRxyQD8V8Ewf+EYnFZBh5TrmGyT/xBp6L0DKmAXfAPv8YiR+jJOUGvmktqjEmuuu/ZehCihGAKrh/Sf+Y9Mf6gK2BC/dypsDMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/enterprise/Move_User_16x16.png
// module id = Bcc0
// module chunks = 0